import { z } from 'zod'
import { oc } from '@orpc/contract'

// Pins or unpins a Frequently used facility by its place id. Google place ids are URL-safe
// (a legacy facility's is 'org:' + its FHIR id); the id reaches a FHIR search, where ','
// means OR, so nothing else may reach it.
export const facilityDiscoveryBookmarkInputSchema = z.object({
  placeId: z.string().regex(/^(org:)?[A-Za-z0-9_-]{1,300}$/),
  bookmarked: z.boolean(),
})

export const facilityDiscoveryBookmark = oc
  .route({ method: 'POST', path: '/v2/facility-discovery/bookmark' })
  .input(facilityDiscoveryBookmarkInputSchema)
  .output(z.object({ ok: z.literal(true) }))
